import {post, get, patch} from '@/lib/axios';

const user = {
  async login(username, password, lang, remember_me) {
    return post('/user/login', {username, password, lang, remember_me});
  },
  async logout() {
    return get('user/logout');
  },
  async logoutRedirect() {
    return get('user/logout-redirect');
  },

  async logoutKeycloak() {
    return get('user/keycloak-logout-by-user');
  },
  async is_auth(params) {
    return get('/user/is-auth', params);
  },
  async forgot_pass(email) {
    return post('/user/forgotpassword', {email});
  },
  async load_user(id) {
    return get(`/user/${id}`);
  },
  async save_user_info(id, data) {
    return patch(`/user/${id}`, data);
  },
  async change_pass(data) {
    return patch(`/user/password`, data);
  },
  async user_points(id) {
    return get(`/user/${id}/points`);
  },
  async get_user_points() {
    return get(`/user/points`);
  },
  async add_user(data) {
    return post(`/user`, data);
  },
  async get_users(page_size, page_num, organization, role, spec, name, by, order) {
    return get('user', {page_size, page_num, organization, role, spec, name, by, order});
  },
  async get_users_form() {
    return get(`/user/form`);
  },
  async users_filters() {
    return get(`/user/filter`);
  },
  async activate_user(user_id) {
    return patch(`/user/${user_id}/activate`);
  },
  async decline_user(user_id) {
    return patch(`/user/${user_id}/decline`);
  },
  async users_requests(page_size, page_num, by, order) {
    return get(`/user/requests`, {page_size, page_num, by, order});
  },
  async update_language(lang) {
    return patch(`/user/update/lang`, lang);
  },
};

export {user as default};
